export default {
  privateMessages: [],
  privateMessagesSendTo: [],
  privateMessagesSendFrom: [],
  coursesOfPrivateMessage: [],
  processing: false,
  error: null,
  success: null,
}



